import { type ReactElement, useState } from 'react';
import { theme } from 'antd';
import styles from './style.module.less';
import type { ResizableProps } from './types';

export function Resizable({
  children,
  resizable,
  resizableName = 'local-resizable-width' }: ResizableProps): ReactElement {
  const localKey = resizableName ?? 'local-resizable-width';
  const [width, setWidth] = useState(resizableName != null ? Number(localStorage.getItem(localKey) ?? 300) : 0);
  const { token } = theme.useToken();

  if (!resizable) {
    return (
      <>{children}</>
    );
  }

  // 设置宽度，默认300
  function handleMouse(event: React.MouseEvent<HTMLElement> | MouseEvent): void {
    if (event.type === 'mousedown') {
      document.addEventListener('mousemove', handleMouse);
      document.addEventListener('mouseup', handleMouse);
      return;
    }

    if (event.type === 'mouseup') {
      document.removeEventListener('mousemove', handleMouse);
      document.removeEventListener('mouseup', handleMouse);
      return;
    }

    setWidth(prevWidth => {
      // 最大600 最小300
      const currentWidth = Math.min(Math.max(prevWidth + event.movementX, 300), 600);

      if (resizableName != null) {
        localStorage.setItem(localKey, currentWidth.toString());
      }

      return currentWidth;
    });
  }

  const style: Record<string, string> = {
    '--resize-bar-color': token.colorPrimary
  };

  return (
    <div className={styles.resizableContainer} style={style}>
      <div className={styles.resizableLine} style={{ width }}>
        {children}
      </div>

      <div className={styles.resizeBox} onMouseDown={handleMouse} onMouseUp={handleMouse} />
    </div>
  );
}
